import { EmailEventsQueryVariables } from "@/app/EmailEvents/GraphQL/emailEventListQuery";
import {
  ModelType,
  QueryEmailEventsOrderByColumn,
  SortOrder,
} from "@/gql/graphql";

export function getObjectEmailEventsVariables(
  objectType: ModelType,
  objectId: string,
): EmailEventsQueryVariables {
  return {
    object_type: objectType,
    object_id: objectId,
    orderBy: [
      { column: QueryEmailEventsOrderByColumn.CreatedAt, order: SortOrder.Asc },
    ],
  };
}
